module.exports = __webpack_public_path__ + "assets/img/Doering_Beilage_02-2024.c1ae6647.jpg";